// Module
var code = `<ex-mono-occurrence-ecran menu-bandeau="vm.menuBandeau" formulaire="vm.formulaireSeg" mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;